// Best-of SEO landings configuration.
// Each topic becomes a page at /best/:slug
export const BEST_OF_TOPICS = {
  "dressage-app": {
    en: {
      title: "Best Dressage Apps in 2026",
      lede: "Sensor data, automatic gait recognition and on-demand video coaching — the seven strongest apps for dressage riders this year.",
      h1: "Best Dressage Apps in 2026",
      intro:
        "Dressage rewards precision. The best dressage apps give you objective data on rhythm, symmetry, impulsion and timing, and pair it with high-quality video coaching. Picks below combine sensor-driven analytics, on-demand lessons and a competition module.",
      slugs: ["equestic-saddleclip", "equilab", "ridely", "horseanalytics", "equisight"],
      keywords: ["best dressage app", "dressage horse app", "apps for dressage riders"],
    },
    nl: {
      title: "Beste Dressuur Apps in 2026",
      lede: "Sensor-data, automatische gangherkenning en on-demand video-coaching — de sterkste apps voor dressuurruiters.",
      h1: "Beste Dressuur Apps in 2026",
      intro:
        "Dressuur draait om precisie. De beste dressuur-apps geven je objectieve data over ritme, symmetrie, impuls en timing, gekoppeld aan kwalitatieve videolessen.",
      slugs: ["equestic-saddleclip", "equilab", "ridely", "horseanalytics", "equisight"],
      keywords: ["beste dressuur app", "dressuur paardenapp", "apps voor dressuurruiters"],
    },
  },
  "breeding-software": {
    en: {
      title: "Best Horse Breeding Software in 2026",
      lede: "Deep pedigrees, mare planning and AI breeding advice. The five strongest platforms for sport-horse and racing breeders.",
      h1: "Best Horse Breeding Software in 2026",
      intro:
        "Breeding software needs depth: multi-generation pedigrees, mare cycle planning, foal records and AI-driven stallion comparison. Generic horse apps fall short here.",
      slugs: ["breeders-app", "equinegenie", "equitrace", "crio-online", "equisight"],
      keywords: ["best horse breeding software", "breeders app", "pedigree software"],
    },
    nl: {
      title: "Beste Fokkerij Software voor Paarden 2026",
      lede: "Diepe stambomen, merrieplanning en AI-fokadvies. De sterkste platforms voor sportpaardenfokkers.",
      h1: "Beste Fokkerij Software voor Paarden 2026",
      intro:
        "Fokkerijsoftware vraagt om diepte: meerdere generaties stamboom, merriecyclus-planning, veulendossiers en AI-gestuurde hengstenvergelijking.",
      slugs: ["breeders-app", "equinegenie", "equitrace", "crio-online", "equisight"],
      keywords: ["beste fokkerij software paarden", "stamboom software paarden"],
    },
  },
  "stable-management": {
    en: {
      title: "Best Stable Management Software in 2026",
      lede: "Boarding contracts, invoicing, staff scheduling and barn ops — software built for professional barns.",
      h1: "Best Stable Management Software in 2026",
      intro:
        "Pension barns live or die on cash flow and clarity. The best stable management software automates boarding billing, schedules staff and gives clients a clean portal.",
      slugs: ["stables-co", "stable-secretary", "barnmanager", "equinem", "equinegenie"],
      keywords: ["best stable management software", "boarding barn software"],
    },
    nl: {
      title: "Beste Stalmanagement Software 2026",
      lede: "Pensioncontracten, facturatie, personeelsplanning en staloperaties — software voor professionele stallen.",
      h1: "Beste Stalmanagement Software 2026",
      intro:
        "Pensionstallen draaien op cashflow en duidelijkheid. De beste stalmanagement-software automatiseert pensionfacturatie, plant personeel en geeft klanten een schoon portaal.",
      slugs: ["stables-co", "stable-secretary", "barnmanager", "equinem", "equinegenie"],
      keywords: ["beste stalmanagement software", "pensionstal software"],
    },
  },
  "riding-tracker": {
    en: {
      title: "Best Horse Riding Tracker Apps in 2026",
      lede: "Automatic ride logging, gait recognition, GPS and training analytics — the apps that win on tracking.",
      h1: "Best Horse Riding Tracker Apps in 2026",
      intro:
        "Ride tracking is the most-used feature in the entire horse-app category. The strongest apps log distance, speed and gaits without you tagging anything manually.",
      slugs: ["equilab", "horseday", "equestic-saddleclip", "horseanalytics", "equisight"],
      keywords: ["best horse riding tracker app", "horse ride tracker", "gps horse app"],
    },
    nl: {
      title: "Beste Rij-Tracker Apps voor Paarden 2026",
      lede: "Automatisch ritten loggen, gangherkenning, GPS en trainingsanalyse.",
      h1: "Beste Rij-Tracker Apps voor Paarden 2026",
      intro:
        "Rit-tracking is verreweg de meest gebruikte functie in de hele paardenapp-categorie.",
      slugs: ["equilab", "horseday", "equestic-saddleclip", "horseanalytics", "equisight"],
      keywords: ["beste rit tracker paard", "rij tracker app paard"],
    },
  },
  "horse-owner-app": {
    en: {
      title: "Best Horse Owner Apps in 2026",
      lede: "One place for vet, farrier, vaccinations and expenses. Apps built for owners with one or more horses.",
      h1: "Best Horse Owner Apps in 2026",
      intro:
        "Owners need a single source of truth. The best owner apps consolidate health records, training notes, farrier visits and ownership expenses in a clean interface.",
      slugs: ["stable-secretary", "happie-horse", "horse-records", "farmkeep", "horsemanage"],
      keywords: ["best horse owner app", "horse owner app"],
    },
    nl: {
      title: "Beste Apps voor Paardeneigenaren 2026",
      lede: "Eén plek voor dierenarts, hoefsmid, vaccinaties en uitgaven.",
      h1: "Beste Apps voor Paardeneigenaren 2026",
      intro:
        "Eigenaren hebben één centrale plek nodig voor gezondheid, training, hoefsmid en kosten.",
      slugs: ["stable-secretary", "happie-horse", "horse-records", "farmkeep", "horsemanage"],
      keywords: ["beste app voor paardeneigenaren"],
    },
  },
  "ai-horse-app": {
    en: {
      title: "Best AI Horse Apps in 2026",
      lede: "AI coaching, AI competition analysis and AI breeding advice — the fastest-growing category in the equestrian world.",
      h1: "Best AI Horse Apps in 2026",
      intro:
        "AI is the most polarising feature in 2026. The best implementations analyse rider position, suggest interval-training adjustments and predict injury risk.",
      slugs: ["equisight", "horseanalytics", "equestic-saddleclip", "breeders-app", "smartpak"],
      keywords: ["best AI horse app", "AI horse coaching app", "AI for horse owners"],
    },
    nl: {
      title: "Beste AI Paardenapps 2026",
      lede: "AI-coaching, AI-wedstrijdanalyse en AI-fokadvies.",
      h1: "Beste AI Paardenapps 2026",
      intro:
        "AI is dé snelst groeiende categorie. De beste implementaties analyseren ruiterhouding en suggereren intervaltraining.",
      slugs: ["equisight", "horseanalytics", "equestic-saddleclip", "breeders-app", "smartpak"],
      keywords: ["beste AI paarden app"],
    },
  },
  "horse-health-app": {
    en: {
      title: "Best Horse Health Apps in 2026",
      lede: "Medication, vaccinations, deworming, vet records and microchip identification.",
      h1: "Best Horse Health Apps in 2026",
      intro:
        "Health apps focus on medical compliance and continuity of care. The strongest apps export cleanly to your vet and let the whole team see the same record.",
      slugs: ["equitrace", "stable-secretary", "farmkeep", "happie-horse", "horse-records"],
      keywords: ["best horse health app", "horse medication tracker"],
    },
    nl: {
      title: "Beste Gezondheidsapps voor Paarden 2026",
      lede: "Medicatie, vaccinaties, ontworming, dierenarts-dossier en chip-identificatie.",
      h1: "Beste Gezondheidsapps voor Paarden 2026",
      intro:
        "Gezondheidsapps zijn de sterkste categorie voor eigenaren met meerdere paarden.",
      slugs: ["equitrace", "stable-secretary", "farmkeep", "happie-horse", "horse-records"],
      keywords: ["beste gezondheidsapp paard"],
    },
  },
  "safety-app-horse-riders": {
    en: {
      title: "Best Safety Apps for Horse Riders in 2026",
      lede: "Fall detection, live GPS, SOS — apps that look after you when nobody else is watching.",
      h1: "Best Safety Apps for Horse Riders in 2026",
      intro:
        "Safety apps are a no-brainer install. Horse Rider SOS in particular is free, life-saving and works in the background of every ride.",
      slugs: ["horse-rider-sos", "equilab", "horseday", "horseanalytics", "equisight"],
      keywords: ["horse rider safety app", "fall detection horse rider"],
    },
    nl: {
      title: "Beste Veiligheidsapps voor Ruiters 2026",
      lede: "Valdetectie, live GPS, SOS — apps die je beschermen tijdens elke rit.",
      h1: "Beste Veiligheidsapps voor Ruiters 2026",
      intro:
        "Veiligheidsapps zijn een no-brainer installatie voor elke ruiter.",
      slugs: ["horse-rider-sos", "equilab", "horseday", "horseanalytics", "equisight"],
      keywords: ["valdetectie ruiter app", "veiligheidsapp paard"],
    },
  },
  "boarding-barn-software": {
    en: {
      title: "Best Boarding Barn Software in 2026",
      lede: "Boarding-first platforms with client portals, recurring billing and barn ops.",
      h1: "Best Boarding Barn Software in 2026",
      intro:
        "Boarding software is a tighter category than general stable management. Look for boarding-first billing, client portals and barn ops on every plan.",
      slugs: ["stables-co", "barnmanager", "stable-secretary", "equinem", "farmkeep"],
      keywords: ["boarding barn software", "horse boarding app"],
    },
    nl: {
      title: "Beste Software voor Pensionstallen 2026",
      lede: "Pension-eerst platforms met klantenportalen, terugkerende facturatie en staloperaties.",
      h1: "Beste Software voor Pensionstallen 2026",
      intro:
        "Pensionsoftware is een striktere categorie dan algemeen stalmanagement.",
      slugs: ["stables-co", "barnmanager", "stable-secretary", "equinem", "farmkeep"],
      keywords: ["pensionstal software", "boarding stal app"],
    },
  },
  "competition-app": {
    en: {
      title: "Best Horse Competition Apps in 2026",
      lede: "Event calendars, start lists, results and FEI/KNHS integration.",
      h1: "Best Horse Competition Apps in 2026",
      intro:
        "Competition modules separate amateurs from pros. The best apps sync with FEI and KNHS so you stop copying scores manually.",
      slugs: ["horseanalytics", "equilab", "barnmanager", "ridely", "equisight"],
      keywords: ["horse competition app", "FEI horse app"],
    },
    nl: {
      title: "Beste Wedstrijd Apps voor Paarden 2026",
      lede: "Wedstrijdkalenders, startlijsten, uitslagen en FEI/KNHS-koppeling.",
      h1: "Beste Wedstrijd Apps voor Paarden 2026",
      intro:
        "Wedstrijdmodules scheiden amateurs van profs. De beste apps koppelen met FEI en KNHS.",
      slugs: ["horseanalytics", "equilab", "barnmanager", "ridely", "equisight"],
      keywords: ["wedstrijd app paard", "FEI app paard"],
    },
  },
};

// Common app slugs eligible for /versus/ pages.
// Generates ~30 highest-value head-to-head landings for the sitemap.
export const VERSUS_PAIRS = [
  ["equisight", "equilab"],
  ["equilab", "horseanalytics"],
  ["equilab", "equestic-saddleclip"],
  ["equilab", "horseday"],
  ["equilab", "ridely"],
  ["equisight", "equinem"],
  ["equisight", "horseanalytics"],
  ["equisight", "barnmanager"],
  ["stable-secretary", "barnmanager"],
  ["stable-secretary", "stables-co"],
  ["stable-secretary", "equinem"],
  ["barnmanager", "equinem"],
  ["barnmanager", "stables-co"],
  ["equinem", "stables-co"],
  ["breeders-app", "equinegenie"],
  ["breeders-app", "equitrace"],
  ["equitrace", "farmkeep"],
  ["horseanalytics", "equestic-saddleclip"],
  ["horseanalytics", "ridely"],
  ["ridely", "equestic-saddleclip"],
  ["horse-rider-sos", "equilab"],
  ["happie-horse", "horse-records"],
  ["horse-records", "horsemanage"],
  ["smartpak", "farmkeep"],
  ["horseday", "equilab"],
  ["equisight", "stable-secretary"],
  ["equilab", "equisight"],
  ["barnmanager", "equisight"],
  ["equinegenie", "crio-online"],
  ["stable-secretary", "horse-records"],
];
